export default __webpack_public_path__ + "static/media/icon_matching_home.31359ead.svg";